// import React, { useEffect, useRef, useState } from "react";
// import Isotope from "isotope-layout";
// import "bootstrap/dist/css/bootstrap.min.css";
// import IMAGE1 from '../assets/images/gallary img2 (1).png';
// import IMAGE2 from '../assets/images/gallary img2.png';
// import IMAGE3 from '../assets/images/gallary img3.png';
// import IMAGE4 from '../assets/images/gallary img4.png';
// import IMAGE5 from '../assets/images/gallary img5.png';
// import IMAGE6 from '../assets/images/gallary img1 (1).png';
// import IMAGE7 from '../assets/images/gallary img3 (1).png';
// import IMAGE8 from '../assets/images/gallary img4 (1).png';
// import IMAGE9 from '../assets/images/gallary img2 (1).png';
// import IMAGE10 from '../assets/images/gallary img5 (1).png';
// import IMAGE11 from '../assets/images/gallary img2 (3).png';
// import IMAGE12 from '../assets/images/gallary img4 (2).png';
// import IMAGE13 from '../assets/images/gallary img4 (3).png';
// import IMAGE14 from '../assets/images/gallary img3.png';
// import LEFTARROW from '../assets/images/leftarrow.png';
// import RIGHTARROW from '../assets/images/rightarrow.png';

// const MasonryGrid = () => {
//   const gridRef = useRef(null);
//   const [showSecondSet, setShowSecondSet] = useState(false);

//   useEffect(() => {
//     if (gridRef.current) {
//       new Isotope(gridRef.current, {
//         itemSelector: ".grid-item",
//         percentPosition: true,
//         layoutMode: "masonry",
//         masonry: {
//           columnWidth: ".grid-sizer",
//         },
//       });
//     }
//   }, [showSecondSet]);

//   const handleToggle = () => {
//     setShowSecondSet((prev) => !prev);
//   };

//   return (
//     <div>
//       <div className="flex justify-between items-center">
//         <h1 className="lg:text-[64px] md:text-[36px] text-[28px] text-[#3D52A1] font-bold">GALLERY</h1>
//         <div className="flex  justify-center items-center gap-2">
//           <div>
//             <img src={LEFTARROW} alt="leftarrow" className="lg:w-[45px] md:w-[40px] w-[26px] lg:h-[45px] md:h-[40px] h-[26px] cursor-pointer " onClick={handleToggle} />
//           </div>
//           <div>
//             <img src={RIGHTARROW} alt="rightarrow" className="lg:w-[45px] md:w-[40px] w-[26px] lg:h-[45px] md:h-[40px] h-[26px] cursor-pointer" onClick={handleToggle} />
//           </div>
//         </div>
//       </div>
//       <div className="container position-relative">
//         <div className="row grid" ref={gridRef}>
//           {!showSecondSet ? (
//             <>
//               <div className="col-sm-3 grid-item y-2">
//                 <img src={IMAGE1} alt="" className="img-fluid" />
//               </div>
//               <div className="col-sm-3 grid-item">
                
//                 <img src={IMAGE2} alt="" className="img-fluid" />
//               </div>
//               <div className="col-sm-6 grid-item y-2">
//                 <img src={IMAGE3} alt="" className="img-fluid" />
//               </div>
//               <div className="col-sm-3 grid-item">
//                 <img src={IMAGE4} alt="" className="img-fluid" />
//               </div>
//               <div className="col-sm-4 grid-item y-2 md:block hidden">
//                 <img src={IMAGE5} alt="" className="img-fluid" />
//               </div>
//               <div className="col-sm-4 grid-item y-2 md:block hidden">
//                 <img src={IMAGE6} alt="" className="img-fluid" />
//               </div>
//               <div className="col-sm-4 grid-item y-2 md:block hidden">
//                 <img src={IMAGE7} alt="" className="img-fluid" />
//               </div>
//             </>
//           ) : (
//             <>
//               <div className="col-sm-3 grid-item y-2">
//                 <img src={IMAGE8} alt="" className="img-fluid" />
//               </div>
//               <div className="col-sm-3 grid-item">
//                 <img src={IMAGE9} alt="" className="img-fluid" />
//               </div>
//               <div className="col-sm-6 grid-item y-2">
//                 <img src={IMAGE10} alt="" className="img-fluid" />
//               </div>
//               <div className="col-sm-3 grid-item">
//                 <img src={IMAGE11} alt="" className="img-fluid" />
//               </div>
//               <div className="col-sm-4 grid-item y-2 md:block hidden">
//                 <img src={IMAGE12} alt="" className="img-fluid" />
//               </div>
//               <div className="col-sm-4 grid-item y-2 md:block hidden">
//                 <img src={IMAGE13} alt="" className="img-fluid" />
//               </div>
//               <div className="col-sm-4 grid-item y-2 md:block hidden">
//                 <img src={IMAGE14} alt="" className="img-fluid" />
//               </div>
//             </>

            
//           )}
//           <div className="grid-sizer col-1"></div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default MasonryGrid;

import React, { useEffect, useRef, useState } from "react";
import Isotope from "isotope-layout";
import "bootstrap/dist/css/bootstrap.min.css";
import IMAGE1 from '../assets/images/gallery.jpg';
import IMAGE2 from '../assets/images/gallery2.jpg';
import IMAGE3 from '../assets/images/gallery3.jpg';
import IMAGE4 from '../assets/images/gallery4.jpg';
import IMAGE5 from '../assets/images/gallery5.jpg';
import IMAGE6 from '../assets/images/gallery6.jpg';
import IMAGE7 from '../assets/images/gallery7.jpg';
import IMAGE8 from '../assets/images/gallery8.jpg';
import IMAGE9 from '../assets/images/gallery9.jpg';
import IMAGE10 from '../assets/images/gallery10.jpg';
import IMAGE11 from '../assets/images/gallery11.jpg';
import IMAGE12 from '../assets/images/gallery12.jpg';
import IMAGE13 from '../assets/images/gallery13.jpg';
import IMAGE14 from '../assets/images/gallery14.jpg';
import LEFTARROW from '../assets/images/leftarrow.png';
import RIGHTARROW from '../assets/images/rightarrow.png';

const MasonryGrid = () => {
  const gridRef = useRef(null);
  const [showSecondSet, setShowSecondSet] = useState(false);

  useEffect(() => {
    if (gridRef.current) {
      new Isotope(gridRef.current, {
        itemSelector: ".grid-item",
        percentPosition: true,
        layoutMode: "masonry",
        masonry: {
          columnWidth: ".grid-sizer",
        },
      });
    }
  }, [showSecondSet]);

  const handleToggle = () => {
    setShowSecondSet((prev) => !prev);
  };

  return (
    <div>
      <div className="flex justify-between items-center">
        <h1 className="lg:text-[64px] md:text-[36px] text-[28px] text-[#3D52A1] font-bold">GALLERY</h1>
        <div className="flex justify-center items-center gap-2">
          <div>
            <img 
              src={LEFTARROW} 
              alt="leftarrow" 
              className={`lg:w-[45px] md:w-[40px] w-[26px] lg:h-[45px] md:h-[40px] h-[26px] cursor-pointer ${
                !showSecondSet ? "opacity-50 cursor-not-allowed" : ""
              }`} 
              onClick={showSecondSet ? handleToggle : null} 
            />
          </div>
          <div>
            <img 
              src={RIGHTARROW} 
              alt="rightarrow" 
              className={`lg:w-[45px] md:w-[40px] w-[26px] lg:h-[45px] md:h-[40px] h-[26px] cursor-pointer ${
                showSecondSet ? "opacity-50 cursor-not-allowed" : ""
              }`} 
              onClick={!showSecondSet ? handleToggle : null} 
            />
          </div>
        </div>
      </div>
      <div className="container position-relative">
        <div className="row grid" ref={gridRef}>
          {!showSecondSet ? (
            <>
              <div className="col-sm-3 grid-item y-2">
                <img src={IMAGE1} alt="" className="img-fluid" />
              </div>
              <div className="col-sm-3 grid-item">
                <img src={IMAGE2} alt="" className="img-fluid" />
              </div>
              <div className="col-sm-6 grid-item y-2">
                <img src={IMAGE6} alt="" className="img-fluid" />
              </div>
              <div className="col-sm-3 grid-item">
                <img src={IMAGE4} alt="" className="img-fluid" />
              </div>
              <div className="col-sm-4 grid-item y-2 md:block hidden">
                <img src={IMAGE5} alt="" className="img-fluid" />
              </div>
              <div className="col-sm-4 grid-item y-2 md:block hidden">
                <img src={IMAGE3} alt="" className="img-fluid" />
              </div>
              <div className="col-sm-4 grid-item y-2 md:block hidden">
                <img src={IMAGE7} alt="" className="img-fluid" />
              </div>
            </>
          ) : (
            <>
              <div className="col-sm-3 grid-item y-2">
                <img src={IMAGE8} alt="" className="img-fluid" />
              </div>
              <div className="col-sm-3 grid-item">
                <img src={IMAGE10} alt="" className="img-fluid" />
              </div>
              <div className="col-sm-6 grid-item y-2">
                <img src={IMAGE9} alt="" className="img-fluid" />
              </div>
              <div className="col-sm-3 grid-item">
                <img src={IMAGE11} alt="" className="img-fluid" />
              </div>
              <div className="col-sm-4 grid-item y-2 md:block hidden">
                <img src={IMAGE12} alt="" className="img-fluid" />
              </div>
              <div className="col-sm-4 grid-item y-2 md:block hidden">
                <img src={IMAGE13} alt="" className="img-fluid" />
              </div>
              <div className="col-sm-4 grid-item y-2 md:block hidden">
                <img src={IMAGE14} alt="" className="img-fluid" />
              </div>
            </>
          )}
          <div className="grid-sizer col-1"></div>
        </div>
      </div>
    </div>
  );
};

export default MasonryGrid;

